import { render } from "./RevenueByClassReport.vue?vue&type=template&id=6989235f&scoped=true"
import script from "./RevenueByClassReport.vue?vue&type=script&lang=js"
export * from "./RevenueByClassReport.vue?vue&type=script&lang=js"

import "./RevenueByClassReport.vue?vue&type=style&index=0&id=6989235f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6989235f"]])

export default __exports__